export const virtualizedTableCellStyle = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};
export const materialCols = [
    {
        field: 'name',
        title: 'Name',
        width: '30%',
    },
    {
        field: 'bicswift',
        title: 'BIC / SWIFT',
        width: '30%',
    },
    {
        field: 'country.name',
        title: 'Country',
        width: '30%',
    },
    //leave 10% for actions
];
const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
};
export const data = new Array(10000).fill(null).map(() => ({
    aba: null,
    address: '',
    isActive: Math.random() >= 0.5,
    bicswift: getRandomInt(2, 5000),
    country: { id: 148, name: 'Norway', isoCode: 'NO', isEUMember: false },
    fedwire: null,
    hasAgreement: false,
    id: Math.random().toString(5),
    name: Math.random().toString(36),
}));
